import L from 'leaflet'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import { WeatherPlayBack } from '@map-sdk/sdk/plugins/Trackplayer/WeatherPlayBack'
import { ElaneForecastData } from '@map-sdk/sdk/plugins/Trackplayer/ElaneForecastData'
import { GetCurrvoyageNew } from '@map-sdk/sdk/plugins/Trackplayer/GetCurrvoyageNew'
import { multipoint } from '@map-sdk/sdk/plugins/Trackplayer/multipoint'
import { WeatherServiceImpl } from '@map-sdk/sdk/plugins/weather/WeatherServiceImpl'
import type { Track } from '@map-sdk/sdk/plugins/Trackplayer/TrackServiceImpl'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

/*
 * @Author: Yolo
 * @Date: 2024-06-14 13:22:00
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-06-18 10:10:17
 * @Desc 航线预测
 */
class TrackForecast {
  //目的港名称
  destName = ''
  destID = ''
  mmsi = ''
  //平均航速
  speed = 0
  hash: any[] = [] // 具体类型根据实际情况定义
  //目的地缓存
  hashDest: { [key: string]: any } = {}
  //离开港
  starPort = ''
  str = ''
  //离港时间
  DepPortTime = true
  //离港时区
  startTimeZone = 99
  //目的港时区
  endTimeZone = 99
  //本地时区
  localZone = 8
  private _map: MyMap
  private markObjs: Record<string, any>
  private hashMark: Record<string, any>
  private yuceLine: any
  private yucePoints: any
  weathLy: any
  weathLyGroup!: L.LayerGroup<any>
  originShip: any
  weatherPlayBack: any
  type!: string
  drawShipWeatherCanvas = new L.Canvas()

  // 构造函数
  constructor(map: MyMap) {
    // 初始化操作
    this._map = map
    this.markObjs = {}
    this.hashMark = {}
    this.mmsi = '4131101'
  }

  //开始预测
  begin() {
    this.startTimeZone = 99
    this.endTimeZone = 99
    this.clearLineAndMark()
    //目的地港口Id
    const _destid = 621474
    const _speed = 12

    // TODO: 获取当前选中的船舶
    const selShip = {
      mmsi: 4131101,
      lat: 38.727367,
      lon: 121.13555,
      lng: 121.13555,
      ais_time: 1718341930,
      lastdyn: 1718341930,
    }

    this.getForecastPoints(
      this.mmsi,
      _destid, //目的地港口
      _speed, // 航速 必须大于等于 0
      selShip.lat,
      selShip.lon || selShip.lng,
      selShip.lastdyn
    )

    // this.showForecastWeatherDetail('windColor')
  }

  //获取预测点数据
  getForecastPoints(
    mmsi: string,
    destid: number,
    speed: number,
    lat: number,
    lon: number,
    aisTime: number
  ) {
    console.log(aisTime)
    // this.hideWeatherLayer()
    //mmsi=413370760&portid=12710&speed=7.9082375&lon=121.45565&lat=28.39393&ais_time=1568255324
    const d = ElaneForecastData
    if (d.status == 0) {
      this.hashDest = d.data
      const ps = d.data.route as any
      this.endTimeZone =
        d.data.porttimezone == undefined || d.data.porttimezone == ''
          ? this.endTimeZone
          : Number.parseFloat(d.data.porttimezone)
      if (ps.length > 0) {
        let tmp = [{ lon, lat }]
        tmp = tmp.concat(ps)
        let points: any[] = []

        tmp.forEach((item, i) => {
          if (tmp[i + 1])
            points = points.concat(this.polylineArc(item, tmp[i + 1]))
          else points.push(item)
        })

        //去除两点间距离小于100米点
        const rpoints: any[] = []
        points.forEach((p) => {
          if (rpoints.length == 0) rpoints.push(p)
          else {
            if (
              L.latLng(p).distanceTo(L.latLng(rpoints[rpoints.length - 1])) >
              100
            ) {
              rpoints.push(p)
            }
          }
        })

        this.yucePoints = rpoints
        this.drawForecastWeather(rpoints, speed)
        this.yuceLine = this._map.trackService.addAndShow(
          'forecast_yuceline',
          rpoints.map((item) => ({
            ...item,
            lat: item.lat * 1000000,
            lng: item.lng * 1000000,
            lon: item.lon * 1000000,
          })),
          {
            lineWeight: 2,
            lineColor: '#dc3c96',
            circleOverColor: '#f60',
            dash: true,
            dashArray: [5, 5],
            middleShow: false,
            isShowTip: false,
            stopShow: false,
            slowShow: false,
            directionShow: false,
            isShowLable: false,
            isDilute: false,
            startShow: false,
            endShow: false,
            startCircleType: 0,
            endCircleType: 2,
            tipHideTimeOut: 30000,
            lableFields: ['name', 'mmsi'],
          } as any,
          { name: d.data.EnName, mmsi }
        )
        this.endMark(rpoints[rpoints.length - 1])
        this.getCurrentVoyage(mmsi) //当前航次
      } else {
        this.yucePoints = []
        console.log('未找到预测航线，请更换查询条件')
      }
    }
  }

  //绘制底部气象逻辑
  drawForecastWeather(latLngs: any[], speed: number) {
    if (!this.weathLy) {
      this.weathLyGroup = L.layerGroup().addTo(this._map)
      this.weathLyGroup.setZIndex(100)
    }
    this.weathLyGroup && this.weathLyGroup.clearLayers()
    this.originShip = this._map.shipsService.getShipByMmsi(this.mmsi, false)
    const result = this.inferPointWeather(latLngs, speed) as any
    //挂在气象数据
    const lst = this.dealWeather(
      this.dealWeather(
        latLngs.map((c: any) => {
          c.weather =
            ((result && result.data) || []).find(
              (d: any) => d.time == c.forecasttime
            ) || null
          return c
        })
      )
    )
    this.hashDest.weather = lst
    this.drawTypeChange()
    lst.length &&
      this._map.setZoom(this._map.getZoom() <= 5 ? 5 : this._map.getZoom() - 1)
  }
  drawTypeChange(type = 'windColor') {
    const weatherDataList = this.hashDest.weather.slice()
    if (!weatherDataList || weatherDataList.length === 0) {
      return
    }
    this.type = type
    this.showForecastWeatherDetail(type)
  }

  inferPointWeather(latLngs: any, speed: any) {
    let c, distance, prev
    //utc
    const _utc = this.originShip.lastdyn * 1000
    for (let i = 0; i < latLngs.length; i++) {
      c = latLngs[i]
      prev = latLngs[i - 1]
      if (i == 0) c.forecasttimeUTC = _utc
      else {
        distance = L.latLng(c).distanceTo(prev)
        //推测utc(1.852 * 1000)
        const diff = distance / (speed * (1.852 * 1000))
        c.forecasttimeUTC = prev.forecasttimeUTC + diff * 3600 * 1000
      }
      //气象数据利用前一包数据
      c.forecasttime = new WeatherServiceImpl(this._map).getCurDate(
        new Date(c.forecasttimeUTC),
        false
      )
    }

    // $.ajax({
    //   url: 'http://127.0.0.1:4523/m1/3339587-0-default/oceanweather/v1/multipoint',
    //   type: 'POST',
    //   dataType: 'JSON',
    //   data: {
    //     x: latLngs.map((c: { lng: any }) => c.lng).join(','),
    //     y: latLngs.map((c: { lat: any }) => c.lat).join(','),
    //     source: 1,
    //     type: '11,12,13,14,15,18',
    //     time: '',
    //     forecasttime: latLngs.map((item: { forecasttime: any }) => item.forecasttime).join(',')
    //   }
    // })
    //tip 1 从接口中匹配出气象数据
    return multipoint
  }
  //处理气象点展示
  dealWeather(latLngs: any) {
    //初始配置
    const common = {
      //#1976d24d
      //color: [null,"#1976d24d","#00cc004d","#eeeb3d4d","#ee7F004d","#EE40004d","#B222224d"],
      color: [
        null,
        'rgba(25,118,210,.3)',
        'rgba(0,204,0,.3)',
        'rgba(238,235,61,.3)',
        'rgba(238,127,0,.3)',
        'rgba(238,64,0,.3)',
        'rgba(178,34,34,.3)',
      ],
      k: [
        -32767, 11.25, 33.75, 56.25, 78.75, 101.25, 123.75, 146.25, 168.75,
        191.25, 213.75, 236.25, 258.75, 281.25, 303.75, 326.25, 348.75, 360,
      ],
    }
    const wind = {
      color: {
        k: [-32767, 8, 11, 15, 19, 23, 56],
        v: common.color,
      },
      type: {
        k: [-32767, 5, 8, 11, 15, 19, 23, 27, 31, 35, 39, 43, 48, 56],
        v: [
          '未知',
          '3~4级',
          '4~5级',
          '5~6级',
          '6~7级',
          '7~8级',
          '8~9级',
          '9~10级',
          '10~11级',
          '11~12级',
          '12~13级',
          '13~14级',
          '14~15级',
          '15~16级',
        ],
      },
      dir: {
        k: common.k,
        v: [
          '未知',
          '南',
          '南西南',
          '西南',
          '西西南',
          '西',
          '西西北',
          '西北',
          '北西北',
          '北',
          '北东北',
          '东北',
          '东东北',
          '东',
          '东东南',
          '东南',
          '南东南',
          '南',
        ],
      },
    }
    const wave = {
      color: {
        k: [-32767, 1.4, 2.9, 3.9, 4.9, 5.9, 26],
        v: common.color,
      },
      dir: {
        k: common.k,
        v: [
          '未知',
          '北',
          '北东北',
          '东北',
          '东东北',
          '东',
          '东东南',
          '东南',
          '南东南',
          '南',
          '南西南',
          '西南',
          '西西南',
          '西',
          '西西北',
          '西北',
          '北西北',
          '北',
        ],
      },
    }
    const getDescript = (
      o: { [x: string]: string | any[]; k: any; v: any },
      v: any
    ) => {
      let ret = v[0]
      for (let i = 0; i < o['k'].length; i++) {
        if (v <= o.k[i]) {
          ret = o.v[i]
          break
        }
      }
      return ret
    }
    /* 处理气象显示 */
    return latLngs.map(
      (ll: {
        weather: {
          windColor?: any
          windspeed: any
          waveColor?: any
          waveheight: any
        }
      }) => {
        if (!ll.weather) {
          ll.weather = {
            windspeed: -32767,
            waveheight: -32767,
          }
        }
        if (ll.weather) {
          ll.weather.windColor = getDescript(wind.color, ll.weather.windspeed)
          ll.weather.waveColor = getDescript(wave.color, ll.weather.waveheight)
        }
        return ll
      }
    )
  }

  //结束点
  endMark(p: Track) {
    if (p == undefined) return
    if (this.markObjs['yuce']) {
      this._map.removeLayer(this.markObjs['yuce'])
    }
    const endPort = this.hashDest
    const sig = L.icon({
      iconUrl: 'https://cdn.xplusship.com/img/images/port.png',
      iconSize: [16, 26], // size of the icon
      shadowSize: [0, 10], // size of the shadow
      iconAnchor: [8, 26], // point of the icon which will correspond to marker's location
      shadowAnchor: [0, 0], // the same for the shadow
      popupAnchor: [-2, -6],
    })
    const newP = CanvasShipUtils.GPSEncryptByMapToLatLng(
      L.latLng(Number(p.lat), Number(p.lng)),
      this._map
    )
    const m = L.marker([newP.lat, newP.lng], { icon: sig })
    const d = Number.parseInt(`${endPort.sailing_time / 24}`)
    const diffDay = d > 0 ? `${d} d ` : ''
    const _utc =
      new Date(endPort.eta.replace(new RegExp('-', 'g'), '/')).getTime() -
      8 * 3600000
    let htm = `<div class="forecast_popup">
    <div class="" style="text-align:center">
    <b class="fz_14 text_overflow"><span style="color:#2a8bbb">${
      endPort.EnName
    } ${endPort.CnName} </span></b>
    </div>
    <p class="">剩余航程：<span class="fz_12   text_overflow">${
      endPort.distance
    } nm </span></p>
    <p class="">剩余时间：<span class="fz_12   text_overflow">${diffDay}${(
      endPort.sailing_time % 24
    ).toFixed(1)} h </span>
    </p>
    <p class="">预到时间：<span class="fz_12   text_overflow"  title="${CommUtils.dataFormat(
      new Date(_utc + 8 * 3600000),
      'MM/DD HH:mm'
    )}" >${CommUtils.dataFormat(
      new Date(_utc + 8 * 3600000),
      'MM/DD HH:mm'
    )}  UTC+8</span>
    </p>`
    if (this.endTimeZone != 99) {
      htm += `<p class="">预到时间：<span class="fz_12 text_overflow">${CommUtils.dataFormat(
        new Date(_utc + this.endTimeZone * 3600000),
        'MM/DD HH:mm'
      )} LT</span></p>`
    }
    htm += '<div class="clear"></div>'
    htm += '</div>'

    //标签
    m.bindTooltip(`${htm}`, {
      direction: 'top',
      permanent: true,
      className: 'my_css_forecast',
    })

    //存储添加
    this.markObjs['yuce'] = m
    m.addTo(this._map)
    m.openPopup()
  }

  //当前航次
  getCurrentVoyage(mmsi: string) {
    console.log(mmsi)
    const d = GetCurrvoyageNew.data as any
    if (d != null && d.deptime != '') {
      const _startPort =
        d.depCountryCode == 'CN' ? d.depportname_cn : d.depportname_en
      this.starPort = _startPort
      this.startTimeZone =
        d.depportzone == undefined || d.depportzone == '未知'
          ? this.startTimeZone
          : Number.parseFloat(d.depportzone)
    }
  }

  //显示气象列表
  showForecastWeatherDetail(type: string | number) {
    const list = this.hashDest.weather.slice()
    if (!list || list.length == 0) return
    const dealEmpty = (n: number) => (n == -32767 ? '--' : n)
    const playSpeed = 60
    const time = Math.ceil(Date.now() / 1000)
    const points = list.map((item: any, index: number) => {
      const getWeather = (weather: any) => {
        if (weather.weather[type]) {
          return {
            ...weather.weather,
            timeutc:
              new Date(weather.weather.time.replace(/-/g, '/')).getTime() /
              1000,
            playtime: time + playSpeed * index,
          }
        }
      }
      return {
        ...item,
        weather: getWeather(item),
      }
    })

    const exceptStyle = (v: number, type: string) => {
      let style = ''
      if (v == -32767) return style
      switch (type) {
        case 'windspeed':
          if (v >= 8) style = 'background:rgba(0,204,0);color:#fff'
          break
        case 'waveheight':
          if (v >= 1) style = 'background:#EEE5DE;'
          break
        case 'temperature':
          if (v >= 30) style = 'background:#ff5a00;color:#fff'
          if (v <= -10) style = 'background:#00ffdc;color:#fff'
          break
        case 'pressure':
          if (v >= 1025) style = 'background:#96ff00;color:#fff'
          if (v <= 1000) style = 'background:#00ffbe;color:#fff'

          break
      }
      return style
    }
    const endPort = this.hashDest
    const eta = new Date(
      endPort.eta.replace(new RegExp('-', 'g'), '/')
    ).getTime()
    const _utc = eta - 8 * 3600000

    const createHeader = () => {
      return `
    <p class="item">时间</p>
    <p class="item">风速(米/秒)</p>
    <p class="item">风向(度)</p>
    <p class="item">浪高(米)</p>
    <p class="item">温度(摄氏度)</p>
    <p class="item">气压(hPa)</p>
  `
    }

    let s = ''
    s += '<div id="castbox" class="castbox">'
    s += '</div>'
    s += '<div class="forecast_left">'
    s += createHeader()
    s += '</div>'
    s += '<div class="forecast_table">'
    s += '<table><tr style="background: #eaeaea;">'
    points.forEach((item: any, index: number) => {
      s += `<td  width="100px" data-idx="${index}" class="clickFlag">${CommUtils.dataFormat(
        item.forecasttimeUTC,
        'MM-DD HH:ss'
      )}</td>`
    })
    s += '</tr><tr>'
    points.forEach((item: any, index: number) => {
      const style = exceptStyle(item.weather.windspeed, 'windspeed')
      s += `<td data-idx="${index}" style="${style}" >${dealEmpty(
        item.weather.windspeed
      )}</td>`
    })
    s += '</tr><tr>'
    points.forEach((item: any, index: number) => {
      const style = exceptStyle(item.weather.windspeed, 'windspeed')
      s += `<td data-idx="${index}"  style="${style}">${dealEmpty(
        item.weather.winddir
      )}</td>`
    })
    s += '</tr><tr>'
    points.forEach((item: any, index: number) => {
      const style = exceptStyle(item.weather.waveheight, 'waveheight')
      s += `<td data-idx="${index}"  style="${style}">${dealEmpty(
        item.weather.waveheight
      )}</td>`
    })
    s += '</tr><tr>'
    points.forEach((item: any, index: number) => {
      const style = exceptStyle(item.weather.temperature, 'temperature')
      s += `<td data-idx="${index}"  style="${style}">${dealEmpty(
        item.weather.temperature
      )}</td>`
    })
    s += '</tr><tr>'
    points.forEach((item: any, index: number) => {
      const style = exceptStyle(item.weather.pressure, 'pressure')
      s += `<td data-idx="${index}"  style="${style}">${dealEmpty(
        item.weather.pressure
      )}</td>`
    })
    s += '</tr></table>'
    //如果
    //if (_utc * 1000 > points[points.length - 1].forecasttimeUTC) {
    //    if (points.length) s += ' <span class="forecast_tooltip" style="text-align: center;margin-left: 350px;top: 84px;font-size: 13px;margin-right: 5px;position: absolute;display: inline-block;"> 气象预测最多预测到未来7天</span>'
    //}
    //if (_utc * 1000 < points[points.length - 1].forecasttimeUTC && points.length)
    if (points.length)
      s += ` <span class="forecast_tooltip" style="text-align: center;margin-left: 350px;top: 84px;font-size: 13px;margin-right: 5px;position:absolute;display: inline-block;"> 预测气象仅预测到下一港,船舶预计${CommUtils.dataFormat(
        new Date(_utc + 8 * 3600000),
        'MM月DD日 HH:mm'
      )}抵达港口</span>`
    s += '</div><div class="forecast_right">'
    s +=
      '<i class="fa fa-angle-double-right" style="margin-top: 80px;"></i><p style="font-size: 12px;">更多</p>'
    //s += '<p class="item more">更多</p>'
    //s += '<p class="item">风速(米/秒)</p>'
    //s += '<p class="item">风向(度)</p>'
    //s += '<p class="item">浪高(米)</p>'
    //s += '<p class="item">温度(摄氏度)</p>'
    //s += '<p class="item">气压(hPa)</p>'
    s += '</div>'
    s += '</div>'
    const forecastPanel = L.DomUtil.create(
      'div',
      'foreacast_panel',
      this._map._container
    )

    // 更新HTML内容并淡入显示
    if (forecastPanel) {
      forecastPanel.innerHTML = s
      forecastPanel.offsetHeight // 触发重绘，以便动画生效
      forecastPanel.style.opacity = '1' // 使用CSS opacity实现淡入效果，需预先在CSS中设置opacity: 0;
    }
    // 获取元素
    // const  = document.querySelector('.foreacast_panel') as HTMLElement
    const forecastTooltip = document.querySelector(
      '.forecast_tooltip'
    ) as HTMLElement
    const forecastRight = document.querySelector(
      '.forecast_right'
    ) as HTMLElement
    const forecast = document.querySelector(
      '.foreacast_panel table'
    ) as HTMLElement

    // 设置宽度
    const width = 110 * points.length
    forecast && (forecast.style.width = `${width}px`)

    // 判断并显示/隐藏右侧按钮
    if (window.innerWidth - 140 > width) {
      forecastRight.style.display = 'none'
    } else {
      forecastRight.style.display = 'block'
    }

    // 调整tooltip的左边距
    if (forecastTooltip) forecastTooltip.style.marginLeft = `${width + 20}px`
    const data = points.map((item: { weather: any }) => item.weather)
    let currentTimePosition =
      (this.weatherPlayBack && this.weatherPlayBack.currentTimePosition) || 0
    this.weatherPlayBack = new WeatherPlayBack({
      container: document.querySelector('#castbox'),
      data,
      playSpeed,
      playCallBack: (time: number) => {
        let idx = -1
        for (const [i, datum] of data.entries()) {
          const c = datum.playtime
          if (c >= time) {
            idx = i
            break
          }
        }
        const playLst = points.slice(0, idx + 1)
        this.playWeatherLayer(playLst)
        if (idx > 0) {
          let angle = null
          //船舶方向
          if (time > currentTimePosition && idx < data.length - 1)
            angle = CanvasShipUtils.getAngleByLatLngToBigCircle(
              {
                lat: points[idx].lat,
                lng: points[idx].lng,
              },
              {
                lat: points[idx + 1].lat,
                lng: points[idx + 1].lng,
              }
            )
          else if (points[idx - 1])
            angle = CanvasShipUtils.getAngleByLatLngToBigCircle(
              {
                lat: points[idx - 1].lat,
                lng: points[idx - 1].lng,
              },
              {
                lat: points[idx].lat,
                lng: points[idx].lng,
              }
            )
          this.updateForecastShip(points[idx], 'playClick', angle)
        } else {
          this._map.shipsService.deleteShipByShipID(this.originShip.shipid)
          this.originShip && this._map.shipsService.addShips([this.originShip])
        }
        currentTimePosition = time
      },
      close: () => {
        const forecastWeather = document.querySelector(
          '#forecast_weather'
        ) as HTMLElement
        forecastWeather && forecastWeather.click()
        //船舶回归初始位置
        this._map.shipsService.deleteShipByShipID(this.originShip.shipid)
        this.originShip && this._map.shipsService.addShips([this.originShip])

        this.weatherPlayBack && this.weatherPlayBack.removeAll()
        this._map.shipsService.restoreZIndex()
        this.hideWeatherLayer()
      },
      clearLayer: () => {
        this.weathLyGroup && this.weathLyGroup.clearLayers()
      },
    })
    this.playWeatherLayer(points)
    //事件
    this.tableEvt(points)
  }

  tableEvt(points: any[]) {
    const clickFlagCells = document.querySelectorAll(
      '.foreacast_panel table td.clickFlag'
    )

    clickFlagCells.forEach((cell: any) => {
      cell.addEventListener('click', () => {
        if (this.weatherPlayBack) this.weatherPlayBack.playStop()

        const selectedCells = document.querySelectorAll(
          '.foreacast_panel table td.areaplayer-td-sel'
        )
        selectedCells.forEach((cell) => {
          cell.classList.remove('areaplayer-td-sel')
        })

        const idx = Number(cell.dataset.idx)
        const selectedCell = document.querySelector(
          `.foreacast_panel table td[data-idx='${idx}']`
        )
        let angle = null
        if (selectedCell) {
          selectedCell.classList.add('areaplayer-td-sel')
          if (points[idx + 1]) {
            angle = CanvasShipUtils.getAngleByLatLngToBigCircle(
              { lat: points[idx].lat, lng: points[idx].lng },
              { lat: points[idx + 1].lat, lng: points[idx + 1].lng }
            )
          } else if (points[idx - 1]) {
            angle = CanvasShipUtils.getAngleByLatLngToBigCircle(
              { lat: points[idx - 1].lat, lng: points[idx - 1].lng },
              { lat: points[idx].lat, lng: points[idx].lng }
            )
          }
          this.updateForecastShip(points[idx], 'click', angle)
        } else {
          if (points[1]) {
            angle = CanvasShipUtils.getAngleByLatLngToBigCircle(
              { lat: points[0].lat, lng: points[0].lng },
              { lat: points[1].lat, lng: points[1].lng }
            )
          }
          this.updateForecastShip(points[0], 'click', angle)
        }
      }) // 维持正确的this上下文
    })

    const forecastRight = document.querySelector('.forecast_right')
    if (forecastRight) {
      forecastRight.addEventListener('click', () => {
        const forecast = document.querySelector(
          '.forecast_table'
        ) as HTMLElement
        const forecastTable = document.querySelector(
          '.forecast_table table'
        ) as HTMLElement
        if (forecastTable && forecast) {
          const tableWidth = forecastTable.offsetWidth
          const containerWidth = forecast.offsetWidth
          const currentScroll = forecast.scrollLeft
          const maxScroll = tableWidth - containerWidth

          forecast.scrollLeft =
            currentScroll < maxScroll ? currentScroll + containerWidth : 0
        }
      })
    }

    // 由于原代码中的on和off函数是为了兼容性封装的事件监听和移除，这里直接使用了addEventListener和removeEventListener，因此这部分不再重复定义。

    const forecastTableElement = document.querySelector('.forecast_table')

    if (forecastTableElement) {
      forecastTableElement.addEventListener('mousedown', (e: any) => {
        e.target.style.cursor = 'move'
        const startX = e.pageX

        forecastTableElement.addEventListener('mousemove', (ev: any) => {
          const left = ev.pageX - startX
          forecastTableElement.scrollTo({
            left: forecastTableElement.scrollLeft - left,
            behavior: 'smooth',
          })
        })

        forecastTableElement.addEventListener('mouseup', (e: any) => {
          e.target.style.cursor = 'default'
          // forecastTableElement.removeEventListener('mousemove', moveHandler)
        })

        e.preventDefault()
      })
    }
  }

  //更新预测船位置
  updateForecastShip(
    next: { lat: any; lng: any; forecasttimeUTC: number },
    from: string,
    nextAngle: number | null
  ) {
    const ship = this._map.shipsService.getShipByMmsi('4131101', false)

    if (next && ship) {
      //更新船位
      let angle = CanvasShipUtils.getAngleByLatLngToBigCircle(
        { lat: ship.lat, lng: ship.lng },
        { lat: next.lat, lng: next.lng }
      )
      if (angle < 0) angle += 360
      if (angle > 360) angle -= 360
      //点击船舶 取船舶
      if (from)
        angle = nextAngle || (this.originShip && this.originShip.hdg) || 0
      this._map.shipsService.deleteShipByShipID(ship.shipid)
      const forecastShip = Object.assign(ship, {
        lat: next.lat,
        lng: next.lng,
        hdg: angle,
        hdg_source: angle,
        cog: angle,
        tracks: [],
        bodyArea: [],
        istop: true,
        lastdyn: next.forecasttimeUTC / 1000,
      })
      this._map.shipsService.addShips([forecastShip] as any)
    }
    this._map.shipsService.setZIndex(450)
  }

  playWeatherLayer(lst: any = []) {
    this.weathLyGroup && this.weathLyGroup.clearLayers()
    if (!lst || lst.length <= 1) return

    const type = this.type || 'windColor'
    //绘制线
    const latLngs: any = []
    const colors: any = []
    lst.forEach((p: any) => {
      // const next = lst[i + 1]
      const latlng = CanvasShipUtils.GPSEncryptByMapToLatLng(p, this._map)
      if (p.weather[type]) {
        latLngs.push(latlng)
        colors.push(p.weather[type])
      }
    })
    const polycolor = L.polycolor(latLngs, {
      renderer: this.drawShipWeatherCanvas,
      weight: 20,
      colors,
      interactive: true,
    })
    polycolor.on('click', () => {
      ///alert(e);
      // var layerPoint = this._map.latLngToContainerPoint(e.target._source.point[0]);
      //alert(layerPoint);
    })
    this.weathLyGroup.addLayer(polycolor)
  }

  //打开窗体
  showWin(mmsi: string, dest: string) {
    //本地与utc的时差
    this.localZone = (new Date().getTimezoneOffset() / 60) * -1
    //清楚绘制
    this.clearLineAndMark()
    this.destName = dest || ''
    this.mmsi = mmsi
    let htm = ''
    htm += '<div class="forecast_box">'
    htm += `    <p>目的港：<input type="text" id="_f_dest" class="" placeholder="请输入目的港" value="${dest}" maxlength="20"  style="width:186px"   /></p>`
    htm +=
      '    <p style="position:relative">&nbsp;&nbsp;&nbsp;速度：<input type="text" id="_f_speed"  class="_number"  maxlength="4"   style="width:52px;margin-right:28px"  /><span class="_speedup"> </span><span class="_speeddown"> </span>节<a href="javascript:void(0)" style="margin-left:30px" onclick="elane.forecast.begin()" class="btn blue_btn">预测</a></p>'
    htm += '    <p style="position:relative">'
    htm +=
      '    <i id="forecast_weather" class="fa fa-toggle-off" style="display: inline-block;font-size: 25px;line-height: 28px;margin-top: 12px;margin-left: 13px;color: #aaa;">'
    htm +=
      '    <span style="font-size: 14px;margin-left: 8px;height: 28px;vertical-align: bottom;color: #666;">显示预测气象</span></i></p>'
    htm +=
      '    <p style="color:#f60;margin-top: -4px;text-align:left;padding-left: 66px;" ><span class="_forecast_tip" style="display:none"></span></p>'
    htm +=
      '    <p style="color:#f60;margin-top:10px;text-align:left;padding-left:10px" ><span class="_forecast_tip" style="display:none"></span></p>'
    htm += '</div>'
    this.clearLineAndMark()
    //关闭播放
    this.weatherPlayBack && this.weatherPlayBack.removeAll()
    this.originShip &&
      this._map.shipsService.deleteShipByShipID(this.originShip.shipid)
    this.originShip && this._map.shipsService.addShips([this.originShip])
    this._map.shipsService.restoreZIndex()
    this.yucePoints = []
    // this.getSpeetByDest(this.mmsi, dest)
    // this.bindEvent()
  }
  //关闭窗体
  closeWin() {
    this.clearLineAndMark()
  }

  //清空线和点
  clearLineAndMark() {
    if (this.markObjs['yuce']) {
      this._map.trackService.remove('forecast_yuceline')
      this._map.removeLayer(this.markObjs['yuce'])
    }
    if (this.markObjs['history']) {
      this._map.trackService.remove('forecast_historyline')
      this._map.removeLayer(this.markObjs['history'])
    }
    this.hideWeatherLayer()
  }

  hideWeatherLayer() {
    this.weathLyGroup && this.weathLyGroup.clearLayers()
    document.querySelectorAll('.foreacast_panel').forEach((element: any) => {
      element.style.display = 'none'
    })
    //map.shipsService.setZIndex(300)
    // this.restoreMapCss()
  }

  polylineArc(
    _from: { lon: any; lat: any; lng?: any },
    _to: { lon: any; lat: any; lng?: any }
  ) {
    _from.lng = _from.lng || _from.lon
    _to.lng = _to.lng || _to.lon

    const pointDis = 50 * 1852

    const _GCinterpolate = (f: number) => {
      const A = Math.sin((1 - f) * d) / Math.sin(d)
      const B = Math.sin(f * d) / Math.sin(d)
      const x =
        A * Math.cos(fromLat) * Math.cos(fromLng) +
        B * Math.cos(toLat) * Math.cos(toLng)
      const y =
        A * Math.cos(fromLat) * Math.sin(fromLng) +
        B * Math.cos(toLat) * Math.sin(toLng)
      const z = A * Math.sin(fromLat) + B * Math.sin(toLat)

      const latInterpol =
        (180 / Math.PI) * Math.atan2(z, Math.sqrt(x ** 2 + y ** 2))
      let lngInterpol = (180 / Math.PI) * Math.atan2(y, x)

      const diff = lngInterpol - (fromLng * 180) / Math.PI

      const trunc = (n: number) => {
        return Math[n > 0 ? 'floor' : 'ceil'](n)
      }
      if (diff < 0) {
        lngInterpol = lngInterpol - trunc((diff - 180) / 360) * 360
      } else {
        lngInterpol = lngInterpol - trunc((diff + 180) / 360) * 360
      }
      return [latInterpol, lngInterpol]
    }

    const _GCarc = (npoints: number) => {
      const arrArcCoords = []
      const delta = 1.0 / (npoints - 1)
      for (let i = 0; i < npoints; i++) {
        const step = delta * i
        const coordPair = _GCinterpolate(step)
        arrArcCoords.push(coordPair)
      }
      return arrArcCoords
    }

    let arrLatLngs
    let fromLat = _from.lat
    let fromLng = _from.lng
    let toLat = _to.lat
    let toLng = _to.lng
    fromLat = (fromLat * Math.PI) / 180
    fromLng = (fromLng * Math.PI) / 180
    toLat = (toLat * Math.PI) / 180
    toLng = (toLng * Math.PI) / 180
    const d =
      2.0 *
      Math.asin(
        Math.sqrt(
          Math.sin((fromLat - toLat) / 2.0) ** 2 +
            Math.cos(fromLat) *
              Math.cos(toLat) *
              Math.sin((fromLng - toLng) / 2.0) ** 2
        )
      )
    if (d === 0) {
      arrLatLngs = [[_from.lat, _from.lng]]
    } else {
      const arcpoints = Math.floor(
        L.latLng(_to.lat, _to.lng).distanceTo(L.latLng(_from.lat, _from.lng)) /
          pointDis
      )
      if (arcpoints > 1) arrLatLngs = _GCarc(arcpoints)
      else arrLatLngs = [[_from.lat, _from.lng]]
    }
    return arrLatLngs.map((p: any[]) => {
      return {
        lat: p[0],
        lng: p[1],
      }
    })
  }
}

export { TrackForecast }
